var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMagnifyingColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B2985F",
  d: "m14.107 13.023-1.245 1.293L20.255 22l1.245-1.294-7.393-7.683Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  d: "M15.014 2.633c-3.316-3.51-8.711-3.51-12.027 0-3.316 3.511-3.316 9.224 0 12.734 2.658 2.815 6.653 3.372 9.841 1.674l-1.281-1.357c-2.456 1.045-5.374.516-7.36-1.587-2.655-2.81-2.655-7.383 0-10.194 2.653-2.81 6.973-2.81 9.627 0 2.044 2.165 2.512 5.375 1.408 8.02l1.268 1.343c1.73-3.41 1.238-7.758-1.476-10.632Z"
})));
export default SvgMagnifyingColor;